export default __webpack_public_path__ + "resources/icons/d340-7322.png";